// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2PCEk","inner":"Footer_inner__2upkd","nextIcon":"Footer_nextIcon__27hPv","innerLeft":"Footer_innerLeft__21lYO"};